import TSFile from './TSFile';

export default class TSDownloadFile extends TSFile {

    private _accessToken: string;

    get accessToken(): string {
        return this._accessToken;
    }

    set accessToken(value: string) {
        this._accessToken = value;
    }

    deserialize(restObject: any): TSDownloadFile {
        super.deserialize(restObject);
        this.accessToken = restObject.accessToken;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.accessToken = this.accessToken;
        return restObject;
    }
}





// WEBPACK FOOTER //
// ./src/app/models/TSDownloadFile.ts